<template>
    <div class="BoxBox" v-if="isShowHide">
        <div class="header_top">
            <div class="header_top_content">
<!--                <div class="header_top_content_time" >中国科学院国家授时中心可信授时： {{ timeValue }}</div>-->
                <div class="header_top_content_media">

                    <!--           证书核验         -->
                    <div class="header_top_content_media_item">
                        <span @click="loginShowJump('证书核验')" class="header_top_content_media_item_title" style="vertical-align: middle;"><img src="./images/heyan.png" style="width: 16px;height: 14px;margin-right: 5px;vertical-align: middle;"/>证书核验</span>
                    </div>

                    <!--           版权家合伙人         -->
                    <!-- <div class="header_top_content_media_item partner">
                        <a style="transition: none" href="/chengshihehuoren.html" target="_blank" class="header_top_content_media_item_title">版权家合伙人</a>
                    </div> -->

                    <!--           app         -->
                    <div class="header_top_content_media_item app">
                        <div class="header_top_content_media_item_title">手机App</div>

                        <div class="header_top_content_media_item_drop_down">
                            <div class="header_top_content_media_item_drop_down_container">
                                <div class="header_top_content_media_item_drop_down_app">
                                    <img class="header_top_content_media_item_drop_down_app_img"
                                         src="../../assets/app.png" alt="版权家app">
                                    <div class="header_top_content_media_item_drop_down_app_text">
                                        <p class="header_top_content_media_item_drop_down_app_text_title">版权家<span
                                                class="header_top_content_media_item_drop_down_app_text_title_tagging">APP</span>
                                        </p>
                                        <p class="header_top_content_media_item_drop_down_app_text_sub">扫描二维码</p>
                                        <p>安装版权家客户端</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <!--           小程序         -->
                    <div class="header_top_content_media_item xcx">
                        <div class="header_top_content_media_item_title">小程序</div>
                        <div class="header_top_content_media_item_drop_down">
                            <div class="header_top_content_media_item_drop_down_container">
                                <ul class="header_top_content_media_item_drop_down_xcx">
                                    <li class="header_top_content_media_item_drop_down_xcx_item">
                                        <img class="header_top_content_media_item_drop_down_app_img"
                                             src="../../assets/images/wxxcx.jpg" alt="版权家微信小程序">
                                        <div class="header_top_content_media_item_drop_down_app_text">
                                            <p class="header_top_content_media_item_drop_down_app_text_title">微信<span
                                                    class="header_top_content_media_item_drop_down_app_text_title_tagging">小程序</span>
                                            </p>
                                            <p class="header_top_content_media_item_drop_down_app_text_sub">扫描二维码</p>
                                            <p>使用版权家小程序</p>
                                        </div>
                                    </li>

                                    <li class="header_top_content_media_item_drop_down_xcx_item">
                                        <img class="header_top_content_media_item_drop_down_app_img"
                                             src="../../assets/images/bdxcx.png" alt="版权家百度小程序">
                                        <div class="header_top_content_media_item_drop_down_app_text">
                                            <p class="header_top_content_media_item_drop_down_app_text_title">百度<span
                                                    class="header_top_content_media_item_drop_down_app_text_title_tagging">小程序</span>
                                            </p>
                                            <p class="header_top_content_media_item_drop_down_app_text_sub">扫描二维码</p>
                                            <p>使用版权家小程序</p>
                                        </div>
                                    </li>
                                </ul>

                            </div>

                        </div>
                    </div>

                    <!--           公众号         -->
                    <div class="header_top_content_media_item gzh">
                        <div class="header_top_content_media_item_title">公众号</div>

                        <div class="header_top_content_media_item_drop_down">
                            <div class="header_top_content_media_item_drop_down_container">
                                <div class="header_top_content_media_item_drop_down_app">
                                    <img class="header_top_content_media_item_drop_down_app_img"
                                         src="../../assets/wchart.png" alt="版权家公众号">
                                    <div class="header_top_content_media_item_drop_down_app_text">
                                        <p class="header_top_content_media_item_drop_down_app_text_title">版权家<span
                                                class="header_top_content_media_item_drop_down_app_text_title_tagging">公众号</span>
                                        </p>
                                        <p class="header_top_content_media_item_drop_down_app_text_sub">扫描二维码</p>
                                        <p>进入版权家官方公众平台</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <!--           微博         -->
                    <div class="header_top_content_media_item wb">
                        <div class="header_top_content_media_item_title">微博</div>
                        <div class="header_top_content_media_item_drop_down">
                            <div class="header_top_content_media_item_drop_down_container">
                                <div class="header_top_content_media_item_drop_down_app">
                                    <img class="header_top_content_media_item_drop_down_app_img"
                                         src="../../assets/weibo.png" alt="版权家微博">
                                    <div class="header_top_content_media_item_drop_down_app_text">
                                        <p class="header_top_content_media_item_drop_down_app_text_title">版权家<span
                                                class="header_top_content_media_item_drop_down_app_text_title_tagging">官微</span>
                                        </p>
                                        <p class="header_top_content_media_item_drop_down_app_text_sub">扫描二维码</p>
                                        <p>进入版权家官方微博</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
        <Row class="header">
            <div class="header_content">
                <div class="header_left">
                    <img @click="goMyUserCenter('9')" style="cursor:pointer;" src="../../assets/logo.png" alt='版权登记'/>
                </div>
                <div class="header_right">
                    <div v-for="(item,index) in navList" :key="index">
                        <div v-if="item.type=='text'"
                             :class="item.children && item.children.length!=0 ? 'header_right_item dropDown_icon' : 'header_right_item' ">

                            <!--               非核验按钮           -->
                            <a @click="jumpRouter(item.path,item.temppath)" :class="item.path==pathName?'active':''"
                               v-if="item.type=='text' && item.name!='证书核验' ">{{item.name}}</a>

                            <!--               核验按钮           -->
                            <a @click="loginShowJump(item.name)" :class="item.path==pathName?'active':''"
                                                           v-if="item.type=='text' && item.name=='证书核验'">{{item.name}}</a>

                            <div v-if="item.top=='限时免费'" class="goPersonVip_right">
                                <img src="../../assets/xianshimianfei.png" alt='版权登记'/>
                                <p>限时免费</p>
                            </div>

                            <!--               下拉框            -->
                            <div v-if="item.children && item.children.length!=0" class="header_right_dropDown">
                                <p @click="jumpRouter(item2.path,item2.temppath)" :key="index2"
                                   v-for="(item2,index2) in item.children" class="header_right_dropDown_item">
                                    {{item2.name }}</p>
                            </div>

                        </div>
                        <input @click="loginShowJump(item.name)" :style="{'marginLeft':item.name=='登录/注册'?'30px':'0px'}"
                               v-if="item.name=='登录/注册'?item.type=='button'&&!showphoto:item.type=='button'"
                               type="button" :value="item.name" class="login"/>
                    </div>
                    <div class="showphotow" v-show="showphoto">
                        <img @click="goUsercenter()"
                             style="width:42px;height:42px;margin-left:30px;cursor:pointer;border-radius:50%"
                             :src="avatarUrl?avatarUrl + '?x-image-process=image/resize,m_fixed,w_50,h_50' : userPhoto" alt='版权登记'/>
                        <img class="rotatesy" style="width:11px;height:7px;" src="@/assets/images/xiala-white.png" alt='版权登记'/>
                        <div class="showdiasy">
                            <p @click="goUserCenterFocus()">个人中心</p>
                            <p @click="goMyUserCenter('1')">我的存证</p>
                            <p @click="goMyUserCenter('4')">我的登记</p>
                            <p @click="goMyUserCenter('2')">我的监测</p>
                            <p @click="goMyUserCenter('3')">我的取证</p>
<!--                            <p @click="goMyUserCenter('7')">我的公证</p>-->
<!--                            <p @click="goMyUserCenter('10')">我的保险</p>-->
                            <p @click="goMyUserCenter('5')">法律服务列表</p>
                            <p @click="goMyUserCenter('12')">我的优惠券</p>
                            <p @click="goMyUserCenter('13')">我的订单</p>
                            <p @click="loginouts()">退出登录</p>
                        </div>
                    </div>
                </div>
            </div>
        </Row>
        <div v-if="$store.state.app.showLoginOrRegistter">
            <login @fatherClose="closeLoginMethod" @childFn="parentFn"/>
        </div>
        <!-- 核验 -->
        <verifycode @fatherModal="fatherModal" v-show="showModal" :showIndex='showIndex'></verifycode>
    </div>
</template>

<script>
    import login from '@/views/login.vue'
    import Cookies from "js-cookie";
    import qs from 'qs';
    import {getStore, removeStore, setStore} from './../../libs/storage';
    import axios from 'axios';
    import verifycode from '@/views/vipClip/verification/verifyCode.vue'
    import {_sysGetTime} from "@/api/staticPage.js";
    import moment from 'moment';
    import EventBus from "@/libs/eventBus"

    let currentDate, tempDate, ms = null;

    export default {
        name: "homeHeader",
        components: {
            login,
            verifycode
        },
        data() {

            console.log(process.env.NODE_ENV);
                switch (process.env.NODE_ENV) {
                    case 'test':
                        this.preEnv=false
                        this.testEnv=true
                        this.proEnv=false
                        break
                    case 'pre':
                        this.preEnv=true
                        this.testEnv=false
                        this.proEnv=false
                        break
                    case 'development':
                        this.preEnv=false
                        this.testEnv=true
                        this.proEnv=false
                        break
                    case 'production':
                        this.preEnv=false
                        this.testEnv=false
                        this.proEnv=true
                        break
                }
                let   childrenArr =[];

            //                            {name: '版权资讯', temppath: 'https://news.bqj.cn/bbs'},
//                            {name: '版权资讯', temppath: 'https://testbbs.bqj.cn/discuz/portal.php'},
//                            {name: '版权专栏', temppath: 'https://testbbs.bqj.cn/discuz/plugin.php?id=micxp_expert:expert'},
//                            {name: '版权论坛', temppath: 'https://testbbs.bqj.cn/discuz/forum.php'},
//                            {name: '版权问答', temppath: 'https://testwenda.bqj.cn/whatsns'},
//                            {name: '版权百科', temppath: 'https://testbaike.bqj.cn/hdwiki'}

                if(this.proEnv){
                    childrenArr.push({name: '版权资讯', temppath: 'https://news.bqj.cn/bbs'});
                    childrenArr.push({name: '版权专栏', temppath: 'https://news.bqj.cn/bbs/micxp_expert-main.html'});
                    // childrenArr.push({name: '版权论坛1', temppath: 'https://news.bqj.cn/bbs/forum-2-1.html'});
                }

                if(this.preEnv){
                    childrenArr.push({name: '版权资讯', temppath: 'https://testbbs.bqj.cn/discuz/portal.php'});
                }
                if(this.testEnv){
                    childrenArr.push({name: '版权资讯', temppath: 'https://testbaike.bqj.cn/discuz/portal.php'});
                    childrenArr.push({name: '版权专栏', temppath: 'https://testbaike.bqj.cn/discuz/plugin.php?id=micxp_expert:expert'});
                    childrenArr.push({name: '版权论坛', temppath: 'https://testbaike.bqj.cn/discuz/forum.php'});
                    childrenArr.push({name: '版权问答', temppath: 'https://testbaike.bqj.cn/whatsns'});
                    childrenArr.push({name: '版权百科', temppath: 'https://testbaike.bqj.cn/hdwiki'});
                }



            return {
                isShowHide:true,
                timer: null, //时间定时器
                timeValue: '', //实时时间
                userPhoto: require('@/assets/head.png'),
//              showLoginOrRegistter: false,
                navList: [
                    {name: '首页', path: '/', top: "", type: 'text'},
                    // {
                    //     name: '7天试用会员',
                    //     path: '/shiyong.html',
                    //     top: '限时免费',
                    //     type: 'text',
                    //     temppath: 'https://previp.bqj.cn/seven.html'
                    // },
                    {
                        name: 'VIP服务',
                        path: '',
                        top: "",
                        type: 'text',
                        temppath: '',
                        children: [
                            {
                                name: '7天试用会员',
                                path: '/shiyong.html',
                                top: "",
                                type: 'text',
                                temppath: ''
                            },
                            {
                                name: 'VIP会员',
                                path: '/huiyuan.html',
                                top: "",
                                type: 'text',
                                temppath: ''
                            }
                        ]
                    },
                    {
                        name: '版权综合服务',
                        path: '',
                        top: "",
                        type: 'text',
                        temppath: '',
                        children: [
                            // {
                            //     name: '版权登记三证申请',
                            //     path: '/threeSyndromesActivity',
                            //     top: '',
                            //     type: 'text',
                            //     temppath: ''
                            // },
                            {
                                name: '版权存证',
                                path: '/apply-cert',
                                top: '',
                                type: 'text',
                                temppath: ''
                            },
                            {
                                name: '版权登记',
                                path: '/copyrightRegistration',
                                top: "",
                                type: 'text',
                                temppath: ''
                            },
                            {
                                name: '版权监测',
                                path: '/monitor',
                                top: "",
                                type: 'text',
                                temppath: ''
                            },
                            {
                                name: '版权取证',
                                path: '/evidenceWeb',
                                top: "",
                                type: 'text',
                                temppath: ''
                            },
                            // {
                            //     name: '法律服务',
                            //     path: '/fuwu.html',
                            //     top: "",
                            //     type: 'text',
                            //     temppath: ''
                            // },
                            // {
                            //     name: '版权保险',
                            //     path: '/insurance',
                            //     top: "",
                            //     type: 'text',
                            //     temppath: ''
                            // },
                            // {
                            //     name: '证书核验',
                            //     path: '/verification',
                            //     top: "",
                            //     type: 'text',
                            //     temppath: ''
                            // }
                        ]
                    },
                    {
                        name: '版权交易',
                        path: '',
                        top: "",
                        type: 'text',
                        temppath: '',
                        children: [
                            // {
                            //     name: '短视频交易',
                            //     path: '',
                            //     top: '',
                            //     type: 'text',
                            //     temppath: 'https://vex.bqj.cn/#/'
                            // },
                            // {
                            //     name: '稿件交易',
                            //     path: '',
                            //     top: "",
                            //     type: 'text',
                            //     temppath: 'http://gg.bqj.cn/'
                            // },
                            /*{
                                name: '剧本交易',
                                path: '',
                                top: "",
                                type: 'text',
                                temppath: 'http://www.jp666.com/'
                            },*/
                            {
                                name: 'IP授权',
                                path: '',
                                top: "",
                                type: 'text',
                                temppath: 'https://ipshouquan.bqj.cn/'
                            }
                        ]
                    },
                    /*{
                        name: '版权社区',
                        path: '',
                        top: "",
                        type: 'text',
                        temppath: '',
                        children: childrenArr
                    },*/
                    // {
                    //     name: '证书核验',
                    //     path: '/verification',
                    //     top: "",
                    //     type: 'text',
                    //     temppath: ''
                    // },
                    // {
                    //     name: '活动中心',
                    //     path: '/huodong.html',
                    //     top: "",
                    //     type: 'text',
                    //     temppath: 'https://previp.bqj.cn/huodong.html.html'
                    // },
                    {
                        name: '解决方案定制',
                        path: '/fangan.html',
                        top: "",
                        type: 'text',
                        temppath: 'https://previp.bqj.cn/enterprise.html'
                    },
                    // {
                    //     name: '版权家合伙人',
                    //     path: '/chengshihehuoren.html',
                    //     top: "",
                    //     type: 'text',
                    //     temppath: 'https://previp.bqj.cn/chengshihehuoren.html'
                    // },
                    // {name: '证书核验', path: '4', top: "", type: 'text', temppath: 'https://previp.bqj.cn/enterprise.html'},
                    {name: '登录/注册', path: '5', top: "", type: 'button'}
                ],
                pathName: window.location.pathname,
                showphoto: false,
                tphoto: '',
                defaultphoto: require('./../../assets/head.png'),
                showModal: !1,
                showIndex: '0',
                springFestival: ''
            }
        },
        computed: {
            avatarUrl: function () {
                return this.$store.state.avatarUrl
            }
        },
        watch: {
            $route(to, from) {
                if (getStore('accessToken') == '' && this.$route.query.action == 'ipauth') {
                    this.$store.state.app.showLoginOrRegistter = true
                }
                if(to.path == "/"){
                    this.isShowHide = false;
                    Cookies.set("isShowFooter","no");
                    // EventBus.on('childFn',(photo)=>{
                    //     this.parentFn(photo)
                    // });
                }else{
                    this.isShowHide = true;
                    Cookies.set("isShowFooter","yes");
                }
                let pathname = to.path;
                this.pathName = pathname;
                this.showphoto = Cookies.get("userInfo") ? true : false;
                // if(Cookies.get("userInfo")){
                //   this.tphoto = JSON.parse(Cookies.get("userInfo")).photo;
                // }
            }
        },
        created() {
            this.showphoto = Cookies.get("userInfo") ? true : false;
            if (Cookies.get("userInfo")) {
                this.tphoto = JSON.parse(Cookies.get("userInfo")).photo;
            }


            //顶部时间戳
            if (this.timer) {
                clearInterval(this.timer)
            }
            this.getAndSetTime()

            EventBus.on('childFn',(photo)=>{
               this.parentFn(photo)
            });
            EventBus.on('springFestival',(res)=>{
                this.springFestival = res
            })

        },
        mounted() {

        },
        beforeDestroy() {
            if (this.timer) {
                console.log('销毁时间累计显示')
                clearInterval(this.timer)
            }
        },
        methods: {
            //ucenter通信
            callChild(jscode) {
                // 传参并指定回调执行函数为onBack
                for (let j = 0, len = jscode.length; j < len; j++) {
                    let script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.src = jscode[j] + '&callback=onBack';
                    document.head.appendChild(script);
                }
            },
            goMyUserCenter(number) {
                switch (number) {
                    case '1':
                        this.$router.push({
                            path: '/myExisting'
                        })
                        break;
                    case '2':
                        this.$router.push({
                            path: '/myMonitor'
                        })
                        break;
                    case '3':
                        this.$router.push({
                            // path: '/myEvidence'
                            path: '/evidenceAndTort'
                        })
                        break;
                    case '4':
                        this.$router.push({
                            path: '/myDci'
                        })
                        break;
                    case '5':
                        this.$router.push({
                            path: '/legalOrder'
                        })
                        break;
                    case '6':
                        this.$router.push({
                            path: '/'
                        })
                    case '7':
                        this.$router.push({
                            path: '/myNotarization'
                        })
                        break;
                    case '9':
                        this.$router.push({
                            path: '/'
                        })
                        break;
                    case '10':
                        this.$router.push({
                            path: '/myInsurance'
                        })
                        break;
                    case '12':
                        this.$router.push({
                            path: '/coupon'
                        })
                        break;
                    case '13':
                        this.$router.push({
                            path: '/myOrder'
                        })
                        break;
                    default:
                        break;
                }
            },
            parentFn(payload) {
                this.showphoto = true
                this.tphoto = payload
            },
            jumpRouter(path, temppath) {
                if (path && path != '') {
                    this.pathName = path
                    // if(path=='/vipseven' || path=='/vipPersonal' || path=='/vipEnterprise'){
                    //   window.location.href = temppath
                    // }else{
                    //     this.$router.push({path: path})
                    // }
                    switch (path) {
                        case '/apply-cert':
                            window.open('/apply-cert', '_blank')
                            break;
                        case '/evidenceWeb':
                            window.open('/evidenceWeb', '_blank')
                            break;

                        case '/copyrightRegistration':
                            window.open('/copyrightRegistration', '_blank')
                            break;

                        case '/monitor':
                            window.open('/monitor', '_blank')
                            break;
                        case '/fuwu.html':
                            window.open('/fuwu.html', '_blank')
                            break;
                        case '/shiyong.html':
                            window.open('/shiyong.html', '_blank')
                            break;
                        case '/huiyuan.html':
                            window.open('/huiyuan.html', '_blank')
                            break;
                        case '/verification':
                            this.showModal = !0;
                            break;
                        default:
                            this.$router.push({path: path})
                            break;
                    }
                    return
                } else if (temppath && temppath != '') {

                    switch (temppath) {
                        case 'https://vex.bqj.cn/#/':
                            window.open('https://vex.bqj.cn/#/', '_blank')
                            break;
                        case 'http://gg.bqj.cn/':
                            window.open('http://gg.bqj.cn/', '_blank')
                            break;

                        case 'http://www.jp666.com/':
                            window.open('http://www.jp666.com/', '_blank')
                            break;
                        default:
                            window.location.href = temppath;
                            break;
                    }
                }

            },
            loginShowJump(name) {
                if (name == '登录/注册') {
                    this.$store.state.app.showLoginOrRegistter = true
                }
                else if (name == '证书核验') {
                    this.showModal = !0;
                    // this.$router.push({path: '/index/verificationCenter'})
                }
            },
            fatherModal() {
                let _this = this;
                _this.showModal = !1;
            },
            closeLoginMethod() {
                this.$store.state.app.showLoginOrRegistter = false
            },
            goUsercenter() {
                this.$router.push({path: '/memberInfo'})
            },
            goUserCenterFocus() {
                this.$router.push({path: '/memberInfo'})
            },
            loginouts() {


                let _this = this
                let accessToken = getStore('accessToken');
                let username = '';
                if (Cookies.get("userInfo")) {
                    username = JSON.parse(Cookies.get("userInfo")).account ? JSON.parse(Cookies.get("userInfo")).account : '';
                }
                let params = {
                    username: username
                }
                axios({
                    method: 'post',
                    url: this.API_ROOT_UPLOAD + 'logout',
                    data: qs.stringify(params),
                    headers: {
                        'accessToken': accessToken
                    }
                }).then(function (response) {
                    console.log(response);
                    if (response.code == 200) {
                        //ucenter退出登录
                        let jscode = response.javascript;
                        _this.callChild(jscode);
                        Cookies.remove('accessToken');
                        Cookies.remove('accessToken', {domain: 'bqj.cn'});
                        Cookies.remove('userInfo');
                        // 清空打开的页面等数据
                        // removeStore('accessToken')
                        setStore('accessToken', '');
                        // localStorage.clear();
                        _this.showphoto = false
                        var midPagesa = "_empty" + "?time=" + new Date().getTime() / 500;
                        _this.$router.push(midPagesa);
                        _this.$router.push('/');
                        _this.$store.state.app.showPayWay = false
                        _this.$store.state.app.showLoginOrRegistter = false
                        console.log('++++++++++++++++', _this.showphoto)

                        EventBus.emit("logout", 'bbb');
                        EventBus.emit("data-loginout", 'loginout');

                    }
                })
                    .catch(function (err) {
                        console.log(err);
                    });
            },

            getAndSetTime() {
                if (!this.timer) {
                    this.getTimeFun();
                    let timer = setInterval(() => {
                        this.setTimeFun()
                    }, 1)
                    this.timer = timer;
                }
            },

            setTimeFun() {
                if (tempDate == null) {
                    return
                } else {
                    let nowDate = new Date().getTime() + ms;
                    if (nowDate - currentDate > 1000) {
                        this.getTimeFun()
                    } else {
                        currentDate = nowDate;
                        let setTime = moment(nowDate).format('YYYY-MM-DD HH:mm:ss:SSS');

                        this.timeValue = setTime;
                    }

                }
            },

            getTimeFun() {
                /*_sysGetTime().then((res) => {
                    tempDate = res.data ? res.data : new Date().getTime();
                    currentDate = new Date().getTime();
                    ms = tempDate - currentDate;
                    currentDate = currentDate + ms;

                })*/
            }

        }
    };
</script>

<style lang="less" scoped>
    .BoxBox{
        min-width: 1334px;
    }
    .header_top {
        background: #262626;
        font-size: 14px;
        width: 100%;

        .header_top_content {
            width: 1334px;
            height: 33px;

            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 0 auto;

            .header_top_content_time {
                color: #FFFFFF;
                line-height: 33px;
            }

            .header_top_content_media {
                display: flex;

                .header_top_content_media_item {
                    margin-right: 22px;
                    color: #999999;
                    cursor: pointer;
                    position: relative;

                    &:last-child {
                        margin-right: 0;
                    }

                    .header_top_content_media_item_title {
                        height: 33px;
                        line-height: 33px;
                        color: inherit;
                    }

                    &:hover {
                        color: #fff;

                        .header_top_content_media_item_drop_down {
                            display: block;
                        }

                        &.partner {
                            .header_top_content_media_item_title:before {
                                content: '';
                                background: url(../../assets/images/headerTop_partner_active.png) no-repeat left center;
                                background-size: 18px 16px;
                                padding-left: 20px;
                                height: 16px;
                            }

                        }

                        &.app {
                            .header_top_content_media_item_title:before {
                                content: '';
                                background: url(../../assets/images/headerTop_app_active.png) no-repeat left center;
                                background-size: 16px 16px;
                                padding-left: 16px;
                                height: 16px;
                            }

                        }

                        &.xcx {
                            .header_top_content_media_item_title:before {
                                content: '';
                                background: url(../../assets/images/headerTop_xcx_active.png) no-repeat left center;
                                background-size: 16px 16px;
                                padding-left: 18px;
                                height: 16px;
                            }
                        }

                        &.gzh {
                            .header_top_content_media_item_title:before {
                                content: '';
                                background: url(../../assets/images/headerTop_gzh_active.png) no-repeat left center;
                                background-size: 16px 16px;
                                padding-left: 18px;
                                height: 16px;
                            }
                        }

                        &.wb {
                            .header_top_content_media_item_title:before {
                                content: '';
                                background: url(../../assets/images/headerTop_wb_active.png) no-repeat left center;
                                background-size: 16px 16px;
                                padding-left: 18px;
                                height: 16px;
                            }
                        }


                    }

                    &.partner .header_top_content_media_item_title:before {
                        content: '';
                        background: url(../../assets/images/headerTop_partner.png) no-repeat left center;
                        background-size: 18px 16px;
                        padding-left: 20px;
                        height: 16px;
                    }

                    &.app .header_top_content_media_item_title:before {
                        content: '';
                        background: url(../../assets/images/headerTop_app.png) no-repeat left center;
                        background-size: 16px 16px;
                        padding-left: 16px;
                        height: 16px;
                    }

                    &.xcx .header_top_content_media_item_title:before {
                        content: '';
                        background: url(../../assets/images/headerTop_xcx.png) no-repeat left center;
                        background-size: 16px 16px;
                        padding-left: 18px;
                        height: 16px;
                    }

                    &.gzh .header_top_content_media_item_title:before {
                        content: '';
                        background: url(../../assets/images/headerTop_gzh.png) no-repeat left center;
                        background-size: 16px 16px;
                        padding-left: 18px;
                        height: 16px;
                    }

                    &.wb .header_top_content_media_item_title:before {
                        content: '';
                        background: url(../../assets/images/headerTop_wb.png) no-repeat left center;
                        background-size: 16px 16px;
                        padding-left: 18px;
                        height: 16px;
                    }


                    /*下拉*/

                    .header_top_content_media_item_drop_down {
                        padding-top: 6px;
                        color: #191919;
                        position: absolute;
                        right: 0;
                        z-index: 778;
                        display: none;
                        cursor: default;


                        &:before {
                            content: '';
                            position: absolute;
                            right: 20px;
                            top: 0;
                            width: 14px;
                            height: 7px;
                            background: url(../../assets/images/headerTop_drop_down.png) no-repeat left center;
                            background-size: 14px 7px;

                        }


                        .header_top_content_media_item_drop_down_container {
                            background: #fff url(../../assets/images/headerTop_shadow.png) no-repeat left -10px;
                            background-size: contain;
                            box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.08);
                            border-radius: 4px;

                            .header_top_content_media_item_drop_down_app_img {
                                display: block;
                                width: 88px;
                                height: 88px;
                            }

                            .header_top_content_media_item_drop_down_app_text {
                                padding-left: 21px;
                                white-space: nowrap;
                                font-size: 14px;
                                line-height: 1;

                                .header_top_content_media_item_drop_down_app_text_title {
                                    font-size: 18px;
                                    font-weight: 500;
                                    line-height: 27px;
                                    padding-bottom: 22px;

                                    .header_top_content_media_item_drop_down_app_text_title_tagging {
                                        color: #FFD800;
                                    }


                                }

                                .header_top_content_media_item_drop_down_app_text_sub {
                                    padding-bottom: 10px;
                                }
                            }

                            /*手机app样式*/

                            .header_top_content_media_item_drop_down_app {
                                padding: 40px 33px 37px 34px;
                                display: flex;
                            }


                            /*小程序样式*/

                            .header_top_content_media_item_drop_down_xcx {
                                padding: 40px 0 0 25px;
                                display: flex;

                                .header_top_content_media_item_drop_down_xcx_item {
                                    display: flex;
                                    padding-right: 40px;
                                    padding-bottom: 40px;

                                }
                            }
                        }

                    }

                }


            }
        }
    }

    .header {
        height: 80px;
        background: rgba(0, 0, 0, 1);
        width: 100%;
        text-align: center;

        .header_content {
            height: 80px;
            width: 1334px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 0 auto;
            .header_left {
                img {
                    width: 221px;
                    height: 36px;
                    vertical-align: middle;
                }
            }

            .header_right {
                display: flex;
                justify-content: flex-end;
                align-items: center;
                margin-right: 30px;
                .login{
                    border: none;
                    outline: none;
                    background: none;
                    font-size: 14px;
                    color: #878787;
                    text-align: right;
                    &:hover{
                        color:#FFD800;
                    }
                }
                .header_right_item {
                    position: relative;
                    height: 80px;
                    line-height: 80px;
                    padding: 0 25px;

                    &.dropDown_icon a:after {
                        content: '';
                        padding-left: 12px;
                        height: 10px;
                        background: url(../../assets/images/header_dropDown.png) no-repeat left center;
                        background-size: 10px 10px;

                    }


                    &:hover {

                        &.dropDown_icon a:after {
                            content: '';
                            padding-left: 12px;
                            height: 10px;
                            background: url(../../assets/images/header_dropDown_active.png) no-repeat left center;
                            background-size: 10px 10px;
                        }

                        &.dropDown_icon a {
                            color: #FFD800;
                        }

                        .header_right_dropDown {
                            display: block;
                        }
                    }
                }

                a {
                    height: 20px;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(153, 153, 153, 1);
                    line-height: 20px;
                    /*margin-right: 50px;*/


                    &:hover {
                        /*color: #fff;*/
                        color: #FFD800;

                    }
                }

                .active {
                    color: #ffd800;
                }

                input {
                    width: 85px;
                    height: 34px;
                    border: 1px solid rgba(255, 255, 255, 1);
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 1);
                    line-height: 34px;
                    background: #000;
                    cursor: pointer;
                    outline: none;

                    &:hover {
                        color: #fff;
                    }
                }

                .header_right_dropDown {
                    // position: absolute;
                    // left: 0;
                    // background: #111111;
                    // width: 100%;
                    // box-sizing: border-box;
                    // color: #999999;
                    // font-size: 14px;
                    // display: none;
                    // z-index: 777;
                    position: absolute;
                    left: 50%;
                    width:100%;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    color: #999999;
                    display: none;
                    z-index: 777;
                    top: 69px;
                    height: auto;
                    background: #F5F5F5;
                    box-shadow: 0px 0px 10px 0px rgb(0 0 0 / 10%);
                    border-radius: 8px;
                    padding: 15px;
                    transform: translate(-50%, 0%);
                    font-size: 14px;
                    color: #666666;
                    line-height: 17px;

                    .header_right_dropDown_item {
                        width: 100%;
                        box-sizing: border-box;
                        height: 30px;
                        line-height: 30px;
                        text-align: center;
                        cursor: pointer;

                        &:hover {
                            color:#F9C300;
                        }
                    }
                }


            }
        }

        .description {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.45);
            margin-top: 1vh;
        }

        .showphotow {
            position: relative;

            .showdiasy {
                position: absolute;
                left: 0px;
                background: #fff;
                box-shadow: 0 2px 18px 0 rgba(179, 189, 199, .47);
                border-radius: 4px;
                z-index: 1000;
                width: 110px;
                display: none;

                p {
                    height: 30px;
                    line-height: 30px;
                    cursor: pointer;
                    font-size: 12px;
                    background-color: #fff;
                    color: #929292;
                }

                p:hover {
                    background-color: #f7f9fb;
                    color: #4e4e4e;
                }
            }

            .rotatesy {
                margin-left: 3px;
                margin-bottom: 17px;
            }

            &:hover {
                .showdiasy {
                    display: block;
                }

                .rotatesy {
                    transform: rotate(180deg)
                }
            }
        }

        .goPersonVip_right {
            position: absolute;
            /*right: 0;*/
            /*top: -24px;*/
            right: -25px;
            top: -14px;

            p {
                position: absolute;
                /*top: 2px;*/
                top: -8px;
                left: 8px;
                font-size: 12px;
                font-weight: 400;
                color: rgba(65, 65, 65, 1);
            }
        }
    }
    .springFestival{
        background: url(../../assets/images/chunjie.png) no-repeat left center;
        .header_content {
            height: 80px;
            width: 1334px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 0 auto;
            .header_left {
                img {
                    width: 221px;
                    height: 36px;
                    vertical-align: middle;
                }
            }

            .header_right {
                display: flex;
                justify-content: flex-end;
                align-items: center;
                margin-right: 30px;

                .header_right_item {
                    position: relative;
                    height: 80px;
                    line-height: 80px;
                    padding: 0 25px;

                    &.dropDown_icon a:after {
                        content: '';
                        padding-left: 12px;
                        height: 10px;
                        background: url(../../assets/images/nsjx.png) no-repeat left center;
                        background-size: 10px 5px;

                    }


                    &:hover {

                        &.dropDown_icon a:after {
                            content: '';
                            padding-left: 12px;
                            height: 10px;
                            background: url(../../assets/images/nsjxH.png) no-repeat left center;
                            background-size: 10px 5px;
                        }

                        &.dropDown_icon a {
                            color: #FFD800;
                            transform: rotate(-90deg);
                        }

                        .header_right_dropDown {
                            display: block;
                        }
                    }
                }

                a {
                    height: 20px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 20px;
                    /*margin-right: 50px;*/


                    &:hover {
                        /*color: #fff;*/
                        color: #FFD800;

                    }
                }

                .active {
                    color: #ffd800;
                }

                input {
                    width: 85px;
                    height: 34px;
                    border: 1px solid rgba(255, 255, 255, 1);
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 1);
                    line-height: 34px;
                    background: #e3351b;
                    cursor: pointer;
                    outline: none;

                    &:hover {
                        color: #fff;
                    }
                }

                .header_right_dropDown {
                    position: absolute;
                    left: 0;
                    background: #111111;
                    width: 100%;
                    box-sizing: border-box;
                    color: #999999;
                    font-size: 14px;
                    display: none;
                    z-index: 777;

                    .header_right_dropDown_item {
                        width: 100%;
                        box-sizing: border-box;
                        height: 30px;
                        line-height: 30px;
                        text-align: center;
                        cursor: pointer;

                        &:hover {
                            background: #1B1B1B;
                            color: #FFD800;
                        }
                    }
                }


            }
        }
    }
</style>
